var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOrgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.792 34.585H26.8753V37.6683H23.792V34.585Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2917 16.0835H29.9583C29.1406 16.0835 28.3563 16.4083 27.7781 16.9866C27.1999 17.5648 26.875 18.3491 26.875 19.1668V28.4168H20.7083C19.0079 28.4168 17.625 29.7997 17.625 31.5002V45.3752C17.625 45.784 17.7874 46.1762 18.0765 46.4653C18.3657 46.7544 18.7578 46.9168 19.1667 46.9168H43.8333C44.2422 46.9168 44.6343 46.7544 44.9235 46.4653C45.2126 46.1762 45.375 45.784 45.375 45.3752V19.1668C45.375 18.3491 45.0501 17.5648 44.4719 16.9866C43.8937 16.4083 43.1094 16.0835 42.2917 16.0835ZM20.7083 43.8335V31.5002H29.9583V43.8335H20.7083ZM34.5833 25.3335H31.5V22.2502H34.5833V25.3335ZM40.75 37.6668H37.6667V34.5835H40.75V37.6668ZM40.75 31.5002H37.6667V28.4168H40.75V31.5002ZM40.75 25.3335H37.6667V22.2502H40.75V25.3335Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrgLogo);
export default __webpack_public_path__ + "static/media/noOrgLogo.2956a88afba90f9a07707d337feeda7f.svg";
export { ForwardRef as ReactComponent };